import React from 'react';
import PointContainer from './PointContainer';

const PointRiceIndicatorContainer = ({ point, riceBalance }) => {

  return (
    <div className="bg-gray-50 rounded-lg p-3">
      <div className="flex items-center w-full">
        {/* 밥 점수 영역 */}
        <div className="flex-1 flex items-center justify-center space-x-2">
          <PointContainer point={point} size={32} />
          <div className="flex flex-col">
            <span className="text-xs text-gray-500">밥 점수</span>
            <span className="text-sm font-bold text-gray-900">{point}점</span>
          </div>
        </div>

        {/* 구분선 */}
        <div className="w-px h-8 bg-gray-200 mx-2"></div>

        {/* 쌀 잔액 영역 */}
        <div className="flex-1 flex items-center justify-center space-x-2">
          <div 
            className="flex items-center justify-center"
            style={{
              width: 32,
              height: 32,
            }}
          >
            <img 
              src="/images/rice_1.png" 
              alt={`쌀 잔액 ${riceBalance} 알`}
              className="w-3/4 h-3/4 object-contain"
            />
          </div>
          <div className="flex flex-col">
            <span className="text-xs text-gray-500">쌀 잔액</span>
            <span className="text-sm font-bold text-gray-900">{riceBalance} 알</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PointRiceIndicatorContainer; 